import React from 'react';
import styled from 'styled-components';
//Images
import pasta1 from '../img/pasta1.jpg';
import pasta2 from '../img/pasta2.jpg';
import pasta3 from '../img/pasta3.jpg';
//Animation
import { motion } from 'framer-motion';
import {
  pageAnimation,
  fade,
  lineAnim,
  photoAnim,
  sliderContainer,
  slider,
} from '../animation';
import ScrollTop from '../components/ScrollTop';

const OurWork = () => {
  return (
    <Work
      style={{ background: '#fff' }}
      variants={pageAnimation}
      exit="exit"
      initial="hidden"
      animate="show"
    >
      <ScrollTop />
      <motion.div variants={sliderContainer}>
        <Frame1 variants={slider}></Frame1>
        <Frame2 variants={slider}></Frame2>
        <Frame3 variants={slider}></Frame3>
        <Frame4 variants={slider}></Frame4>
      </motion.div>
      <Movie>
        <motion.h2 variants={fade}>Ravioli al nero di seppia</motion.h2>
        <motion.div variants={lineAnim} className="line"></motion.div>
      
          <Hide>
            <motion.img variants={photoAnim} src={pasta1} alt="athlete" />
          </Hide>
     
      </Movie>
      <Movie>
        <motion.h2 variants={fade}>Ravioli di pesce</motion.h2>
        <motion.div variants={lineAnim} className="line"></motion.div>
     
          <motion.img variants={photoAnim} src={pasta2} alt="the-race" />
       
      </Movie>
      <Movie>
        <motion.h2 variants={fade}>gnocchi</motion.h2>
        <motion.div variants={lineAnim} className="line"></motion.div>
      
          <motion.img variants={photoAnim} src={pasta3} alt="good-times" />
        
      </Movie>
    </Work>
  );
};

const Work = styled(motion.div)`
  min-height: 60vh;
  overflow: hidden;
  padding: 0rem 10rem;
  text-align:center;
  h2 {
    padding: 1rem 0rem;
  }
  @media (max-width: 1200px) {
    padding: 0rem 2rem;
  }
  @media (max-width: 800px) {
    h2{
      font-size:2.7rem;
    }
  }
  @media (max-width: 400px) {
    padding: 0rem 1rem;
  }
`;

const Movie = styled(motion.div)`

 margin: 5rem 0 8rem 0;

  .line {
    height: 0.5rem;
    background: #23d997;
    margin-bottom: 3rem;
  }
  img {
    width: 100%;
    height: 70vh;
    object-fit: cover;
  }
  @media (max-width: 1200px) {
    margin: 3rem 0;
  }
  @media (max-width: 800px) {
    img {
    height: 100%;
  }
  }
`;
const Hide = styled.div`
  overflow: hidden;
`;
//Frame Animation
const Frame1 = styled(motion.div)`
  position: fixed;
  left: 0;
  top: 10%;
  width: 100%;
  height: 100vh;
  background: #fffebf;
  z-index: 2;
`;
const Frame2 = styled(Frame1)`
  background: #ff8efb;
`;
const Frame3 = styled(Frame1)`
  background: #8ed2ff;
`;
const Frame4 = styled(Frame1)`
  background: #8effa0;
`;

export default OurWork;
